import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import Select from 'react-select'

import AlertTemplate from './Alert'
import ImageTemplate from './Image'
import TopbarTemplate from './Topbar'

const components = {
  alert: AlertTemplate,
  image: ImageTemplate,
  topbar: TopbarTemplate
}

export default function Templates({open, setOpen, data, setData}) {
  const [ template, setTemplate ] = useState({})
  const [ code, setCode ] = useState("")

  const handleChange = e => setTemplate(e)

  return (
    <Modal
      className="modal modal__dcm"
      size="lg"
      centered
      show={open}
      onHide={setOpen}
    >
      <Modal.Body>
        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => setOpen()}>
          <i className="lnr lnr-cross"></i>
        </button>

        <h1 className="modal__title">Templates</h1>
        <hr/>

        <div className="titled__group">
          <p>Selecione o Template:</p>
          <Select
            options={[
              {label: "Alerta", value: "alert"},
              {label: "Barra de topo", value: "topbar"},
              {label: "Imagem", value: "image"}
            ]}
            className="basic-select"
            classNamePrefix="select"
            placeholder="Selecione o template"
            onChange={handleChange}
          />
        </div>

        {
          template && template.length !== 0 && template.value !== "" ?
            (() => {
              const Component = components[template.value]
              if ( !Component ) return

              return <Component setOpen={setOpen} data={data} setData={setData}/>
            })()
          : null
        }
      </Modal.Body>
    </Modal>
  )
}